import "./badges-component-styles.scss";

// importing badges
import badgesData from "./badges-data";

const BadgesComponent = () => {
	return (
		<div className="badges-wrapper">
			{badgesData.map((badge) => (
				<img
					src={badge.badge}
					alt={badge.badgeTitle}
					className="badge"
					key={badge.id}
					title={badge.badgeTitle}
				/>
			))}
		</div>
	);
};


export default BadgesComponent;